import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PersistGate } from "redux-persist/integration/react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { createTheme, CssBaseline, StyledEngineProvider } from "@mui/material";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { SnackbarProvider } from "notistack";
import { Provider } from "react-redux";
import { persistor, store } from './store/state';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const theme = createTheme({
  typography: {
    fontSize: 14,
  },
  palette: {
    primary: {
      light: "#F4F3F7",
      main: "#00833D",
      dark: "#595959",
      contrastText: "#fff",
    },
    secondary: {
      light: "#FEE7D5",
      main: "#FF7900",
      dark: "#FFAF78",
      contrastText: "#000",
    },
  },
});

root.render(
  <React.StrictMode>
  <Provider store={store}>
  <PersistGate persistor={persistor}>
      <StyledEngineProvider injectFirst>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
              <SnackbarProvider>
                <App />
              </SnackbarProvider>
            </Router>
          </ThemeProvider>
        </LocalizationProvider>
      </StyledEngineProvider>
      </PersistGate>
  </Provider>
</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
